<ion-grid class=" ion-no-padding">
  <ion-row class="ion-align-items-stretch container">
    <ion-col size-xs="12" size-sm="6" class="claim-col">
      <h3>{{ data.title }}</h3>
      <div class="desc" [innerHTML]="sanitizeService.sanitizeString(data.description)"></div>
      <ion-button target="_blank" [href]="data.url" color="light" fill="outline">
        {{ data.textButton }}
      </ion-button>
    </ion-col>
    <ion-col size-xs="12" offset-sm="1" size-sm="5">
      <div [ngStyle]="{'background-image': 'url(' + data.image + ')' }" class="app-image"></div>
    </ion-col>
  </ion-row>
</ion-grid>
